/**
 * Handle closing modals by clicking on their overlays.
 */
export class TVModalCloser {

    constructor() {
        this.init();
    }

    /**
     * Run the functions allow closing of modals by clicking off of them.
     *
     * @returns {void}
     */
    init() : void {
        const modal_overlays = document.getElementsByClassName('ui-widget-overlay') as HTMLCollectionOf <HTMLElement>;
        const close_buttons = document.getElementsByClassName('ui-dialog-titlebar-close') as HTMLCollectionOf <HTMLElement>;

        for (let i = 0; i < modal_overlays.length; i++) {
            modal_overlays[i].addEventListener('click', () => {
                close_buttons[i].click();
            });
        }

    }

}

export function init_modal_closer() : void {
    // Run this script only if we observe the modal overlay.
    const modal_observer = new MutationObserver(
        (mutationsList, observer) => {
            if (document.contains(document.querySelector('.ui-widget-overlay'))) {
                (() => new TVModalCloser())();
            }
        }
    );

    modal_observer.observe(document, {attributes: false, childList: true, characterData: false, subtree:true});
}
